// extracted by mini-css-extract-plugin
export default {"imageContainer":"TabContentC_imageContainer__t+Aih","box":"TabContentC_box__YBQyY","image":"TabContentC_image__zkqrO"};